import React from 'react'
import { classNames } from 'helpers'

export interface DividerProps {
  className?: string
  text?: string
}

export const Divider: React.FC<DividerProps> = ({
  className,
  text,
  ...args
}) => {
  return (
    <div className={`relative ${className}`} {...args}>
      <div
        className="absolute inset-0 flex items-center"
        aria-hidden="true"
      >
        <div
          className={classNames(
            'w-full border-t',
            !className?.includes('border-') && 'border-blue-1',
            className
          )}
        />
      </div>
      {text && (
        <div className="relative flex justify-center">
          <span className="px-2 font-medium bg-blue-0 -mt-0.5">
            {text}
          </span>
        </div>
      )}
    </div>
  )
}

export default Divider
